import BasicRoute from 'components/routes/BasicRoute'
import FazendaConsulta from 'entity/Fazenda/components/FazendaConsulta'
import FazendaForm from 'entity/Fazenda/components/FazendaForm'
import React from 'react'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-fazenda"
                route="consulta-fazenda"

                menuProps={{
                    text: "Fazendas",
                    sequence: "111113",
                    iconName: "Fence",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<FazendaConsulta />}
            />
            <BasicRoute
                uid="fazenda"
                route="_fazenda"
                element={<FazendaForm />}
            />
        </>
    )
}
